import * as React from "react";
import { FC, useEffect } from "react";
import { Loading, LoadingTheme, LoadingProps as SpinnerProps } from "./Loading";

export type WithLoadingProps<ComponentProps> = ComponentProps & {
    isLoading?: boolean;
    loadData?: F;
};

export const withLoading =
    <P extends object>(Component: FC<P>, spinnerProps?: SpinnerProps) =>
    ({ isLoading, loadData, ...props }: WithLoadingProps<P>) =>
        (
            <WithLoading isLoading={isLoading} loadData={loadData} {...spinnerProps}>
                <Component {...(props as P)} />
            </WithLoading>
        );

export const WithLoading: React.FC<WithLoadingProps<{}> & SpinnerProps> = ({
    isLoading,
    loadData,
    children,
    ...spinnerProps
}) => {
    useEffect(() => void loadData?.(), []);

    return <>{isLoading ? <Loading {...spinnerProps} /> : children}</>;
};

export const WithContentLoading: React.FC<WithLoadingProps<{}> & SpinnerProps> = props => (
    <WithLoading {...props} theme={LoadingTheme.big} fixed={true} />
);
